{
  "it": {
    "dressingRoom": {
      "lead": "Abbina armatura e tuta interna e guarda l'outfit in 3D. Condividilo con un link o accedi per salvarlo.",
      "slots": {
        "helmet": "Casco",
        "torso": "Torso",
        "arms": "Braccia",
        "legs": "Gambe",
        "backpack": "Zaino",
        "undersuit": "Tuta interna",
        "primary": "Primaria",
        "secondary": "Secondaria",
        "sidearm": "Arma da fianco"
      },
      "size": "S%{size}",
      "choose": "Scegli…",
      "remove": "Rimuovi",
      "openItem": "Apri la pagina dell'oggetto",
      "notFound": "Oggetto non trovato",
      "noHolo": "Ancora nessun modello 3D",
      "empty": "Scegli un pezzo per uno slot qualsiasi per vedere l'outfit.",
      "pose": "Posa",
      "copyLink": "Copia link",
      "savedOutfits": "Outfit salvati",
      "signInToSave": "Accedi per salvare gli outfit.",
      "outfitName": "Nome dell'outfit",
      "nameTaken": "Hai già un outfit con questo nome.",
      "saveNew": "Salva come nuovo outfit",
      "saveChanges": "Salva modifiche",
      "noOutfits": "Ancora nessun outfit salvato.",
      "pieces": {
        "one": "%{count} pezzo",
        "other": "%{count} pezzi"
      },
      "confirmDelete": "Eliminare l'outfit %{name}?",
      "messages": {
        "saved": "Outfit salvato.",
        "saveFailed": "Impossibile salvare l'outfit.",
        "deleteFailed": "Impossibile eliminare l'outfit.",
        "linkCopied": "Link copiato.",
        "copyFailed": "Impossibile copiare il link."
      },
      "groups": {
        "armour": "Armatura",
        "weapons": "Armi",
        "gear": "Equipaggiamento"
      },
      "hold": "Impugna",
      "bodies": {
        "male": "Maschile",
        "female": "Femminile"
      },
      "positionPending": "Posizione non ancora esportata",
      "fit": {
        "noPort": "%{item} non ha uno slot per questo",
        "doesNotFit": "Non compatibile con %{item}",
        "noWornPiece": "Nessun pezzo indossato ha posto per questo"
      },
      "armorSets": {
        "open": "Set di armatura",
        "count": {
          "one": "%{count} set",
          "other": "%{count} set"
        }
      },
      "gearHint": "Indossa un torso, delle gambe o una tuta interna per portare granate, caricatori, iniettori e strumenti.",
      "gear": {
        "grenade": "Granata %{number}",
        "magazine": "Caricatore %{number}",
        "gadget": "Gadget",
        "medpen": "Medpen %{number}",
        "oxypen": "Oxypen %{number}",
        "utility": "Utilità %{number}"
      },
      "saveBlocked": "Correggi ciò che è segnalato sopra per salvare questo outfit.",
      "storage": {
        "title": "Spazio",
        "space": "%{used} di %{capacity}",
        "add": "Aggiungi oggetto",
        "fewer": "Uno in meno",
        "more": "Uno in più",
        "pickerTitle": "Aggiungi a %{piece}",
        "problems": {
          "noStorage": "Nulla di indossato qui può contenere questi oggetti.",
          "overCapacity": "Contiene più di quanto questo pezzo possa ospitare.",
          "tooLarge": "Contiene un oggetto troppo grande per questo pezzo.",
          "unmeasured": "Contiene un oggetto senza dimensione misurata."
        },
        "misfit": {
          "unmeasured": "Dimensione non misurata",
          "tooLarge": "Troppo grande per questo pezzo",
          "noRoom": "Spazio insufficiente"
        }
      },
      "gearNone": "Ciò che indossi non ha slot per l'equipaggiamento.",
      "gearColumns": {
        "magazine": "Munizioni",
        "grenade": "Granate",
        "medpen": "Medpen",
        "oxypen": "Oxypen"
      }
    }
  }
}
